import { Controller } from "@hotwired/stimulus"

// Shows the one panel that matches the checked radio, e.g. "One FDD" vs "Many FDDs".
// Each panel names its choice with data-choice-panels-key="<radio value>".
export default class extends Controller {
  static targets = ["choice", "panel"]

  connect() {
    this.show()
  }

  show() {
    const checked = this.choiceTargets.find((radio) => radio.checked)
    const key = checked ? checked.value : null

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.choicePanelsKey !== key
    })
  }
}
